import {observable, computed} from 'mobx'

import {setTranslation, selectSupported, loadTranslation, Locale} from '/shared/locales'

export type {Locale}

export function detect(defaultLocale: Locale = 'en'): Locale {
    let locale = selectSupported(navigator.languages || [navigator.language])
    if (locale)
        return locale
    locale = defaultLocale
    console.warn('Cannot detect locale from navigator, use default one:', locale)
    return locale
}

export class LocaleService {
    @observable
    private saved: Locale | null = selectSupported([localStorage.getItem('locale') ?? ''])

    @computed
    get current(): Locale {
        return this.saved ?? detect()
    }

    @computed
    get currentOrNull(): Locale | null {
        return this.saved
    }

    set(locale: Locale | null) {
        this.saved = locale
        if (locale)
            localStorage.setItem('locale', locale)
        else
            localStorage.removeItem('locale')
    }

    async loadCurrent() {
        setTranslation(await loadTranslation(this.current))
    }
}

export let service!: LocaleService

export function create(): LocaleService {
    service = new LocaleService()
    return service
}
